import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { AppActionCreators } from '../../../actions';
import { TermsOfUseCard } from './TermsOfUseCard';

class TermsOfUseContainer extends Component {
	componentDidMount() {
		const { id } = this.props.match.params;
		if (id) {
			this.props.getTermsOfUse(id);
		}
	}

	componentWillUnmount() {
		this.props.unloadApp();
	}

	render() {
		const { termsOfUse } = this.props;
		return <TermsOfUseCard {...termsOfUse} />;
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		termsOfUse: state.app.termsOfUse
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		...bindActionCreators(AppActionCreators, dispatch),
		...{ goTo: (url) => dispatch(push(url)) }
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(TermsOfUseContainer);
